export const objectKeysDiff = (obj1, obj2) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  return keys1.filter(x => !keys2.includes(x));
};
export default {};
//# sourceMappingURL=utils.js.map